import { render } from "./ErrorCard.vue?vue&type=template&id=b483fac8&scoped=true"
import script from "./ErrorCard.vue?vue&type=script&lang=js"
export * from "./ErrorCard.vue?vue&type=script&lang=js"

import "./ErrorCard.vue?vue&type=style&index=0&id=b483fac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b483fac8"]])

export default __exports__